import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Select } from '../../../_metronic/_partials/controls';
import { useIntl } from 'react-intl';

export const SelectAnswerType = (props) => {
  const intl = useIntl();
  const ObjectStatusTitles = ["MODULES.GENERAL.ANSWER1", "MODULES.GENERAL.ANSWER2", "MODULES.GENERAL.ANSWER3", "MODULES.GENERAL.ANSWER4","MODULES.GENERAL.ANSWER5"];

  return (
    <Select name="answerType" label="نوع پاسخ" {...props}>
      <option key={0} value={0}>
        لطفا انتخاب کنید
      </option>
      {ObjectStatusTitles.map((answerType, index) => (
        <option key={answerType} value={index + 1}>
          {intl.formatMessage({ id: answerType })}
        </option>
      ))}
    </Select>
  )
}